export const TODOS_LOADING = "GET_TODOS_LOADING";
export const TODOS_ERROR = "GET_TODOS_ERROR";

export const GET_TODOS_SUCCESS = "GET_TODOS_SUCCESS";
export const ADD_TODOS_SUCCESS = "ADD_TODOS_SUCCESS";
export const DELETE_TODOS_SUCCESS = "DELETE_TODOS_SUCCESS";
export const UPDATE_TODOS_SUCCESS = "UPDATE_TODOS_SUCCESS";
